import { vehicleFromDto } from "@features/vehicles/mappers/vehiclesMapper";
import { clientFromDto, clientToDto } from "@features/clients/mappers/clientsMapper";

const beneficiaryFromDto = (dto) => {
  if (!dto) return {};

  const { id, softsegurosId, ...rest } = clientFromDto(dto); // Se omiten campos que no se manejan en 'beneficiary'
  return rest;
};

export const quotationFromDto = (dto) => {
  const { id, number, vehicle_data, client_data, beneficiary_same_as_client, beneficiary, sede, ...rest } = dto;

  return {
    ...rest, // TODO: pendiente mapear el resto
    id,
    number,
    vehicle: vehicleFromDto(vehicle_data),
    client: clientFromDto(client_data),
    isBeneficiarySameAsTaker: beneficiary_same_as_client,
    beneficiary: beneficiaryFromDto(beneficiary),
    branchId: sede,
  };
};

const beneficiaryToDto = (data) => {
  if (!data) return {};

  const { id, softseguros_id, ...rest } = clientToDto(data); // Se omiten campos que no se manejan en 'beneficiary'
  return rest;
};

/** Mapea una cotización proveniente de una lista */
export const quotationListItemFromDto = (dto) => ({
  ...dto, // TODO: pendiente realizar el mapeo. Se mantiene el objeto tal cual por compatibilidad
});

export const quotationToDto = (data) => ({
  vehicle_id: data.vehicleId,
  client_id: data.takerId,
  beneficiary_same_as_client: data.isBeneficiarySameAsTaker,
  beneficiary: beneficiaryToDto(data.beneficiary),
  external_quotation: data.externalQuotation,
  sede_id: data.branchId,
  notification_link: data.notificationLink,
});

/** Solo se mapean los campos que pueden ser actualizados por el backend */
export const updateQuotationToDto = (data) => {
  const { beneficiary_same_as_client, beneficiary, sede_id } = quotationToDto(data);

  return {
    beneficiary_same_as_client,
    beneficiary,
    sede_id,
  };
};

export const quotationExecutionDetailsFromDto = (dto = {}) => ({
  quotationInsuranceCarrierId: dto.quotation_insurance_carrier_id,
  insuranceCarrier: {
    id: dto.insurance_carrier?.id,
    name: dto.insurance_carrier?.name,
  },
  connectionType: dto.connection_type,
  state: dto.state,
  timing: {
    queuedAt: dto.timing?.queued_at ?? null,
    startedAt: dto.timing?.started_at ?? null,
    finishedAt: dto.timing?.finished_at ?? null,
    durations: {
      queueMs: dto.timing?.durations?.queue_ms ?? null,
      executionMs: dto.timing?.durations?.execution_ms ?? null,
      totalMs: dto.timing?.durations?.total_ms ?? null,
    },
  },
  log: dto.log,
  errors: {
    log: dto.errors?.log ?? null,
  },
});
